module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-group_white.7cbb3c1d.svg";